module.exports = __webpack_public_path__ + "static/img/stage1_5.1c84d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stageImg/stage1_5.png
// module id = Ee/m
// module chunks = 1